import { render, staticRenderFns } from "./purchaseError.vue?vue&type=template&id=6f2d40eb&"
import script from "./purchaseError.vue?vue&type=script&lang=js&"
export * from "./purchaseError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports